import { Coordinate } from "ol/coordinate";
import { PendingCalculationDTO } from "./pendingCalculation";

export class TerrainHeightDTO{
    coordinate: Coordinate;
    projectId: number;
    navaidId: string;
}

export class TerrainHeightBulkDTO{
    coordinates: Coordinate[];
    projectId: number;
    navaidIds: string[];
    pendingCalculation: PendingCalculationDTO;
}